module.exports = __webpack_public_path__ + "img/zfr3.1b15bf93.jpg";